const journeys = {
  journeyWebsite: {
    header: {
      tagline: "WHOLE-PERSON CARE",
      startTesting: "Start testing",
      navHowItWorks: "How it works",
      navJourneys: "Journeys",
      navAbout: "About",
    },
    faq: {
      title: "FAQ",
      subtitle:
        "Find answers to your questions about our personalized wellness programs and services.",
      whatIncludedQuestion: "What does a Journey include?",
      whatIncludedAnswer:
        "Your selected lab tests — no hidden costs, no insurance required\nInsights and interpretation from your practitioner's team\nClear clinician summary to help you understand your results\nA personalized wellness plan crafted by your practitioner\nAbility to book affordable re-testing as needed to track your improvements over time",
      hsaFsaQuestion: "Is my Journey HSA and FSA Eligible?",
      hsaFsaAnswer:
        "Yes. Journeys are eligible for HSA (Health Savings Account) and FSA (Flexible Spending Account) reimbursement. Lab testing and practitioner-guided wellness programs typically qualify as eligible medical expenses.",
      differenceQuestion:
        "What makes Journeys different from a regular checkup or wellness program?",
      differenceAnswer:
        "Unlike a standard checkup, Journeys provide comprehensive lab testing paired with a personalized interpretation and actionable wellness plan from your practitioner. You get deeper insights, ongoing tracking, and a plan that evolves with your health — not just a snapshot.",
      resultsTimeQuestion: "How long does it take to get my results back?",
      resultsTimeAnswer:
        "Most lab results are available within 5–7 business days after your blood draw. Once results are in, your practitioner will review and interpret them, then share your personalized wellness plan.",
      fullscriptQuestion: "What is Fullscript?",
      fullscriptAnswer:
        "Fullscript is a health and wellness platform that connects patients with their practitioners. It powers the Journeys experience — from lab testing and results tracking to personalized supplement and wellness plans.",
    },
    shareSection: {
      title: "Share ",
      titleItalic: "Journeys",
      subtitle: "Invite friends and family to start their Journey today!",
      bulletInterpretations: "Provider-reviewed interpretations",
      bulletRanges: "Functional optimal ranges",
      bulletNoSubscription: "No subscription required",
      sendInvite: "Send invite",
      urlCopied: "Journeys website URL copied!",
    },
    footer: {
      description:
        "Health Journeys designed by the practitioners at {{-clinicName}}. Testing, interpretation, and a personalized plan — all in one.",
      explore: "Explore",
      browseJourneys: "Browse Journeys",
      howItWorks: "How It Works",
      company: "Company",
      privacy: "Privacy",
      copyright: "© {{year}} {{-clinicName}}. All rights reserved.",
    },
  },
  journeyOfferPage: {
    journeyWith: "Journey with {{-pracName}}",
    title: "The first step on your personal health Journey",
    description:
      "Comprehensive blood panels with a personalized interpretation and action plan to help you live healthier, longer.",
    biomarkers: "<strong>{{count}}</strong> biomarker",
    biomarkers_plural: "<strong>{{count}}</strong> biomarkers",
    personalizedPlan:
      "A personalized plan created by <strong>{{-pracName}}</strong> that evolves with you",
    lifetimeAccess: "<strong>Lifetime access</strong> to results tracked over time",
    hsaEligible: "HSA/FSA eligible",
    oneTimeFee: "One time fee no hidden costs",
    getStarted: "Get started",
    biomarkersPopover: {
      title: "Biomarkers included",
    },
    dontWait: "Don't wait. Starting your preventative Journey is simple",
    howItWorks: "How it works",
    labTesting: "Lab testing",
    labTestingDescription:
      "Order your lab panel focused on the areas that matter most. No waiting rooms. No prescription needed. Just real data, fast.",
    resultsExplainedStep: "Results, clearly explained",
    resultsExplainedDescriptionStep:
      "You'll be able to view and track your results, see what's in range, what's not, and what it means for your health. An expert practitioner translates the data into plain language and clear insights. ",
    personalizedPlanStep: "Personalized Wellness Plan",
    personalizedPlanDescriptionStep:
      "You'll get a personalized wellness plan built around your results. This can include supplements, nutrition, and lifestyle changes. Designed by your practitioner to be realistic, actionable, and effective.",
    retestProgressStep: "Re-test and track progress",
    retestProgressDescriptionStep:
      "Health isn't static, and neither is your plan. Re-testing gives you and your practitioner a clear picture of what's working and what to adjust, so your progress stays on track.",
    footerTitle:
      "This is the first step toward understanding your health more deeply — and taking control, <italic>together with {{-pracName}}</italic>",
    poweredBy: "Powered by",
  },
  JourneysList: {
    title: "Journeys Assistant",
    manageJourneyPanels: "Manage Journey panels",
    copyWebsiteUrl: "Copy website URL",
    invitePatient: "Invite a patient to start a journey",
  },
  JourneysFloatingBar: {
    patientDetailsButtonText: "Next",
    interpretationDetailsButtonText: "Build Wellness Plan",
    patientDetailsTextPrimary: "Next: Review Lab Results and Interpretation",
    patientDetailsTextSecondary:
      "The lab interpretation will <strong>not</strong> be shared with the patient yet",
    interpretationDetailsTextPrimary: "Next: Review Wellness Plan",
    interpretationDetailsTextSecondary:
      "The lab interpretation will <strong>not</strong> be shared with the patient yet",
  },
  WomensHormones: {
    menopauseStatus: {
      pre: "Pre-menopause",
      peri: "Peri-menopause",
      post: "Post-menopause",
    },
    menstrualCyclePhase: {
      follicular: "Follicular Phase",
      luteal: "Luteal Phase",
    },
    WomensHormonesRangeUsed: "Reference range used (based on women's hormones survey)",
  },
};

export { journeys };
